import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import {Tools} from './Tools';
import {Inc,Item,Owner,Customer,TakebackState} from './Inc';
import useStyles from './Styles';
import MultiLines from './MultiLines';
import RowTable from './RowTable';
import {Theme} from './Theme';

interface TakebackConfirmProps {
	isOpen:boolean,
    items:Item[],
    inputs:TakebackState,
    owner:Owner,
    customer:Customer,
    next(): void,
    back(): void,
    close(): void,
}

const TakebackConfirm = (props:TakebackConfirmProps)=> {
	const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

	if(!props.isOpen || !props.customer){
		return (null);
	}
    const addr = "〒" + props.customer.zip + "\n" + props.customer.addr + "\n" + props.customer.name + "様\nTEL:" + props.customer.tel;

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			maxWidth='md'
			fullScreen={fullScreen}
		>
			<DialogTitle color="primary">商品引取</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
				内容に間違いがなければ、「この内容で申請する」を押して下さい。<br/>
				</div>
                <Table style={{marginBottom:'1em'}}>
                    <TableBody>
                        <RowTable name="引き取り方法" noWrap={true} value={Tools.getLabel(Inc.takebackHows,props.inputs.how_id)}/>
                        <RowTable name="お届け先" value={(
							<MultiLines text={addr}/>
						)}/>
						<RowTable name="メッセージ" value={(
							<MultiLines text={props.inputs.message} empty={true}/>
						)}/>
					</TableBody>
                </Table>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeadNowrap} align='center'>引き取る商品</TableCell>
                            <TableCell className={classes.tableHeadNowrap} align='center'>在庫</TableCell>
                            <TableCell className={classes.tableHeadNowrap} align='center'>引き取る数</TableCell>
							{props.inputs.hasSample &&
                            <TableCell className={classes.tableHeadNowrap} align='center'>見本</TableCell>
							}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                {props.items.map( (item:Item,index:number)=>{
					if( props.inputs.values[index]===0 && props.inputs.samples[index]!=="1" ){
						return (null);
					}

					const key = "item"+index;
                    let sample = "";
                    if(item.sample_flag==='1'){
                        if( props.inputs.samples[index]==="1" ){
                            sample = "引き取る";
                        } else {
                            sample = "引き取らない";
                        }
                    }
                    return (
                        <TableRow key={key}>
                            <TableCell className={classes.tableCellDense}>
                                <span className={classes.itemId}>ID:{item.item_id}</span>　
                                <Hidden smUp implementation="js">
                                    <br/>
                                </Hidden>
                                {item.item_name}
                            </TableCell>
                            <TableCell className={classes.tableCellNowrap} align="right">{item.num_stock}</TableCell>
                            <TableCell align='right'>
                                {props.inputs.values[index]}
                            </TableCell>
							{props.inputs.hasSample &&
                            <TableCell className={classes.tableCellNowrap} align='center'>
                                {sample!=="" ? (
                                    <span>{sample}</span>
                                ):(
                                    <span>なし</span>
                                )}
                            </TableCell>
							}
                        </TableRow>
                    );
                })}
                    </TableBody>
                </Table>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='この内容で申請する' onClick1={props.next} button2='修正する' onClick2={props.back} top={0} bottom={0}/>
			</DialogActions>
		</Dialog>				
	);
}

export default TakebackConfirm;
